export const campaignPageSize = 500
export const defaultCampaignParams = {
  fields: ['logo_public_id', 'digital_assets'],
  perPage: campaignPageSize,
  offset: 0,
}
